import React from 'react';

import TextPage from 'Components/TextPage';
import TextPageHeader from 'Components/TextPageHeader';
import text from '../static/text/privacyPolicy.md';

class PrivacyPolicy extends React.Component {
  render() {
    return (
      <main className="Page__content">
        <TextPageHeader
          title="Tinybop Privacy Policy"
          description={
            <React.Fragment>
              <p className="TextPageHeader__paragraph">
                We are committed to protecting your privacy and especially the
                privacy of your children.
              </p>
              <p className="TextPageHeader__paragraph">
                This is a legally binding contract between you and Tinybop
                Schools. Please make sure you read it, because it is important.
                We’ve tried to make it as clear as possible, but we welcome your
                feedback to{' '}
                <a href="mailto:schools.support@tinybop.com">
                  schools.support@tinybop.com
                </a>{' '}
                if you have suggestions or questions.
              </p>
            </React.Fragment>
          }
        />
        <TextPage html={text} />
      </main>
    );
  }
}

export default PrivacyPolicy;
